import { useMemo } from 'react'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import useCurrentUserId from '@shared/hooks/src/useCurrentUserId'
import MeSharedProvider from '@shared/providers/src/MeProvider'
import API from '@shared/services/src/API'
import { QK, UserRole } from '@shared/utils'

/**
 * Wraps shared MeProvider with a query to fetch the current user,
 * and subscribes to PubNub events for the current user.
 */
export default function MeSuspenseProvider({ children }) {
  const userId = useCurrentUserId()

  const { data } = useSuspenseQuery({
    queryKey: QK.me(userId).details,
    queryFn: () => API.me.details(),
  })

  const { data: pharmacy } = useQuery({
    queryKey: QK.pharmacies.id(data?.pharmacyId).details,
    queryFn: () => API.pharmacies.id(data?.pharmacyId).details(),
    enabled: [UserRole.Pharmacy, UserRole.PharmacyManager].includes(data.role) && Boolean(data.pharmacyId),
  })

  const user = useMemo(() => {
    if (!pharmacy) return data
    return { ...data, pharmacy }
  }, [data, pharmacy])

  return <MeSharedProvider value={user}>{children}</MeSharedProvider>
}
